export default function thisYear() {
    const thisYearElement = document.querySelector(".js-this-year");
    if (thisYearElement) {
        thisYearElement.textContent = new Date().getFullYear();
    }
}
